import { render, staticRenderFns } from "./ClaimPAAddEdit.vue?vue&type=template&id=202f422c&scoped=true"
import script from "./ClaimPAAddEdit.vue?vue&type=script&lang=js"
export * from "./ClaimPAAddEdit.vue?vue&type=script&lang=js"
import style0 from "./ClaimPAAddEdit.vue?vue&type=style&index=0&id=202f422c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f422c",
  null
  
)

export default component.exports